import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {checkForFilesInObject, paramGetter} from "./Utils/lib";
import {del, push, set} from 'object-path-immutable';
import request from "../../Services/API/Requests";
import {getParamsFromString} from "./Utils";
import {creatingFilter} from "./Screen/ScreenComponents/ListScreenComponent/List/Utils/creatingFilter";
import {listUncheckAll} from "./Screen/ScreenComponents/ListScreenComponent/List/enqueryList.slice";
import {flatten} from "../ApplicationBuilder/ApplicationDesigner/Designers/ScreenDesigner/utils/flatternArray";

export function getUserFromStorage() {
    try {
        return JSON.parse(sessionStorage.getItem('user') || "{}")
    } catch (e) {
        console.log(e)
        return '';
    }
}
function base64ToBlobUrl(base64, mimeType = '') {
    const byteCharacters = atob(base64);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += 512) {
        const slice = byteCharacters.slice(offset, offset + 512);
        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: mimeType });
    return URL.createObjectURL(blob);
}
const initialState = {
    stringFilter: {}, // {[listID]: "stringFilter"}
    setFilter: {}, // {[listID]: [advancedFilter]}
    listData: {}, // {[listID]: {listData}}
    pivotSettings: {},
    queryParams: {}, //setup from url /screenName/?status=1&value="23"
    screenInfo: {}, //setup from url /screenName/id/screenInfo
    screenName: '',
    loading: false,
    allFieldsDisabled: {}, /* {screenName: <boolean>} */
    refreshData: {},
    popup: {
        name: null,
        returnPath: null,
        parentScreen: null,
    },
    isChangedFields: false,
    screen: {},
    globalValues: {
        session: getUserFromStorage(),
        sessionStorage: Object.keys(sessionStorage).reduce(function (obj, key) {
            obj[key] = sessionStorage.getItem(key);
            return obj
        }, {}),
        param: {},
        inParam: {}
    },
    uploadedFilesLinks: {},
    filesGarbage: {},
    refs: [],
    form: {
        isValid: true
    },
    forms: {},
    dataSources: []
};

function getElementById(id, refs, dispatch) {
    try {
        const ref = Array.isArray(id) ?
            refs.filter(element => id.includes(element.id)).map(v => v.ref) :

            refs.find(v => v.id === id)?.ref;

        return {
            setProperty: (property, value) => {
                if (ref) {
                    dispatch(setComponentProperty({property, value, path: ref}))
                } else {
                    console.log('ref is null')
                }
            }
        }
    } catch (e) {
        console.log(e)
    }
}

const sendRequest = createAsyncThunk('sendRequest', async (payload, thunkAPI) => {
    const {jsonScreen} = thunkAPI.getState();
    const {destination} = payload.action;
    let globalValues = {...jsonScreen.globalValues, ...payload.context};
    let url = getParamsFromString(destination, globalValues, payload.screenName);
    globalValues = await checkForFilesInObject(globalValues, jsonScreen.uploadedFilesLinks, payload.screenName);
    const data = paramGetter({
        action: payload.action,
        globalValues,
        screenName: payload.screenName
    });
    try {
        const reqResponse = await request({url, data});
        return {
            setToVar: payload.action.setToVar,
            data: reqResponse,
            screenName: payload.screenName
        }
    } catch (err) {
        return thunkAPI.rejectWithValue(err)
    }
})
const readRecord = createAsyncThunk('readRecord', async (payload, thunkAPI) => {
    const {jsonScreen: {globalValues}} = thunkAPI.getState();
    const {destination, value} = payload.action;
    const recordId = getParamsFromString(value, {...globalValues, ...payload.context}, payload.screenName);
    try {
        const value = await request({
            url: `${destination}/read`,
            data: {id: recordId}
        });
        return {
            data: value,
            path: `${payload.screenName}.${destination}`,
        }
    } catch (err) {
        return thunkAPI.rejectWithValue(err)
    }
})
const getNewScreen = createAsyncThunk('getNewScreen', async (payload, thunkAPI) => {
    const {id} = payload;
    // const {jsonScreen: {screen}} = thunkAPI.getState();
    try {

        if (!id) return {};

        // if(screen[id]) {
        //     return screen[id]
        // }


        return await request({
            url: `screen/read`,
            data: {id}
        })
    } catch (err) {
        return thunkAPI.rejectWithValue(err)
    }
})
const getListData = createAsyncThunk('getListData', async (payload, thunkAPI) => {
    const {destination, listId} = payload.action;
    try {
        const response = await request({url: 'list/getData', data: {id: listId}});
        return {
            setToVar: destination,
            screenName: payload.screenName,
            data: response
        }
    } catch (e) {
        return thunkAPI.rejectWithValue(e);
    }

})
const startProcess = createAsyncThunk('startProcess', async (payload, thunkAPI) => {
    const {jsonScreen} = thunkAPI.getState();
    const {processId} = payload.action;
    let globalValues = {...jsonScreen.globalValues, ...payload.context};
    let newGlobalValues = await checkForFilesInObject(globalValues, jsonScreen.uploadedFilesLinks, payload.screenName);
    const otherProps = payload.fromAction ? paramGetter({
        action: payload.action,
        globalValues: newGlobalValues,
        screenName: payload.screenName
    }) : payload.action.param;

    try {
        return await request({
            url: "/task/create",
            data: {bpmnId: processId, ...otherProps}
        })
    } catch (err) {
        return thunkAPI.rejectWithValue(err)
    }
})
const startTask = createAsyncThunk('startTask', async (payload, thunkAPI) => {
    const {jsonScreen} = thunkAPI.getState();
    const {taskId} = payload.action;
    let globalValues = {...jsonScreen.globalValues, ...payload.context};
    let newGlobalValues = await checkForFilesInObject(globalValues, jsonScreen.uploadedFilesLinks, payload.screenName);
    const otherProps = payload.fromAction ? paramGetter({
            action: payload.action,
            globalValues: newGlobalValues,
            screenName: payload.screenName
        }
    ) : payload.action.param;
    const task = getParamsFromString(taskId, globalValues, payload.screenName);
    try {
        return await request({
            url: "/task/get",
            data: {taskId: task, ...otherProps}
        })
    } catch (err) {
        return thunkAPI.rejectWithValue(err)
    }
})
const completeTask = createAsyncThunk('completeTask', async (payload, thunkAPI) => {
    const {jsonScreen} = thunkAPI.getState();
    const {taskId} = payload.action;
    let globalValues = {...jsonScreen.globalValues, ...payload.context};
    let newGlobalValues = await checkForFilesInObject(globalValues, jsonScreen.uploadedFilesLinks, payload.screenName);
    const otherProps = payload.fromAction ? paramGetter({
            action: payload.action,
            globalValues: newGlobalValues,
            screenName: payload.screenName
        }
    ) : payload.action.param;
    const task = getParamsFromString(taskId, globalValues, payload.screenName);
    try {
        return await request({
            url: "/task/complete",
            data: {taskId: task, ...otherProps}
        })
    } catch (err) {
        return thunkAPI.rejectWithValue(err)
    }
})
const deleteTask = createAsyncThunk('deleteTask', async (payload, thunkAPI) => {
    const {jsonScreen: {globalValues}} = thunkAPI.getState();
    const {taskId} = payload.action;
    const task = getParamsFromString(taskId, {...globalValues, ...payload.context}, payload.screenName);
    try {
        return await request({
            url: "/task/delete",
            data: {taskId: task}
        })
    } catch (err) {
        return thunkAPI.rejectWithValue(err)
    }
})

const jsExecutor = createAsyncThunk('jsExecutor', async (payload, thunkAPI) => {
    const {jsonScreen, app: {isOpenDrawer, userLanguage}, enqueryList} = thunkAPI.getState();
    const {value: script, actions} = payload.action;
    let queryParams = {};
    try {
        queryParams = jsonScreen.queryParams[jsonScreen.screenName] ?
            jsonScreen.queryParams[jsonScreen.screenName] : {}
    } catch (e) {
        console.log('set query params error', e)
    }

    let globalValues = {
        ...jsonScreen.globalValues,
        _queryParams: queryParams,
        isOpenDrawer,
        userLanguage, ...payload.action.context,
        list: enqueryList
    };
    const refs = jsonScreen.screen?.[jsonScreen.screenName]?._refs || [];

    return await getParamsFromString(script, globalValues, payload.screenName, {
        ...actions,
        setListData: (destination, value) => thunkAPI.dispatch(setListData({
            action: {
                destination,
                param: value
            },
            screenName: payload.screenName
        })),
        setPivot: (destination, value) => thunkAPI.dispatch(setPivotSettings({
            action: {
                destination,
                param: value
            },
            screenName: payload.screenName
        })),
        listUncheckAll: (listId) => thunkAPI.dispatch(listUncheckAll(listId)),
        getElementById: (id) => getElementById(id, refs, thunkAPI.dispatch)
    }, false, payload.generatedScript);
});

export const jsonScreenSlice = createSlice({
    name: 'jsonScreen',
    initialState,
    reducers: {
        setStringFilter: (state, action) => {
            state.stringFilter = action.payload;
        },
        setQueryParams: (state, action) => {
            state.screenInfo = {
                [action.payload.screenName]: action.payload.screenInfo
            }

            state.queryParams = {
                [action.payload.screenName]: action.payload.queryParams
            }

        },
        setScreenName: (state, action) => {
            state.screenName = action.payload;
        },
        setVariable: (state, action) => {
            const {action: {destination}, screenName, screenNameParam} = action.payload;
            const {globalValues: {param}} = state;
            const data = paramGetter({
                action: action.payload.action,
                globalValues: {...state.globalValues, ...action.payload.context},
                screenName: screenName || screenNameParam
            });
            state.globalValues.param = set(param, `${screenName || screenNameParam}.${destination}`, data);
        },
        setFormData: (state, action) => {
            const {globalValues: {param}, screenName} = state;
            const {entity, values} = action.payload;
            const {record, label, status} = values;
            if(record) {
                state.globalValues.param = set(param, `${screenName}.${entity}`, record)
            }

            state.forms[entity] = {label, status}
            //TODO check if field is inside screen (state._fieldRefs.find(v => v.path))
            // return back unresolved fields to caller (doActions) and show messages as notification
            //console.log(status)
        },
        setGlobalValues: (state, action) => {
            state.globalValues.param[action.payload.screenName] = action.payload.data;
        },
        setInParam: (state, action) => {
            state.globalValues.inParam[action.payload.screenName] = action.payload.data;
        },
        clearGlobalValues: (state, action) => {
            const {screenId, isPopup} = action.payload;
            if (state.allFieldsDisabled[screenId]) state.allFieldsDisabled[screenId] = false
            if (state.globalValues.param[screenId]) state.globalValues.param[screenId] = {}
            if (state.globalValues.inParam[screenId]) state.globalValues.inParam[screenId] = null


            //clear file storage
            if (state.filesGarbage[screenId] && state.filesGarbage[screenId].length) {
                state.filesGarbage[screenId].forEach(url => {
                    //TODO do not revoke only for popup-on-close, and popups urls put on parent screen
                    //     URL.revokeObjectURL(url)

                })
                state.filesGarbage[screenId] = [];
                state.uploadedFilesLinks[screenId] = {};

            }
            //clear all setFilter actions
            if (!isPopup) {
                state.setFilter = {};
                state.listData = {};

                //clear form objectL
                state.forms = {};
                state.screen[screenId] = {}
            }
        },
        uploadFile: (state, action) => {
            const {action: act, screenName} = action.payload;
            const {globalValues, uploadedFilesLinks} = state;
            const loadedFile = paramGetter({action: act, globalValues, screenName});
            let isArray = Array.isArray(loadedFile)
            if(act.convertToObjectUrl) {
                const [prefix, base64] = loadedFile.content.split(',');
                const mime = prefix.match(/:(.*?);/)[1];
                loadedFile.content = base64ToBlobUrl(base64, mime)
            }
            //collect file garbage
            if (isArray) {
                let newLoaded = loadedFile.map(({content}) => {
                    return content
                })
                state.filesGarbage[screenName] = [...state.filesGarbage[screenName] || [], ...newLoaded];
            } else {
                state.filesGarbage[screenName] = push(state.filesGarbage[screenName], '', loadedFile.content)
            }

            if (act.setToVar) {
                uploadedFilesLinks[screenName] = push(uploadedFilesLinks[screenName], '', act.setToVar)
                globalValues.param[screenName] = set(globalValues.param[screenName], act.setToVar, loadedFile)
            }
        },
        setLoading: (state, action) => {
            state.loading = action.payload;
        },
        disableAllFields: (state, action) => {
            state.allFieldsDisabled[action.payload.screenName] = true;
        },
        enableAllFields: (state, action) => {
            state.allFieldsDisabled[action.payload.screenName] = false;
        },
        refreshData: (state, action) => {
            state.refreshData[action.payload.destination] = true;
        },
        setRefreshDataFalse: (state, action) => {
            state.refreshData[action.payload] = false;
        },
        setFilter: (state, action) => {

            if(!action.payload.action) return

            //clear filter
            if(!action.payload?.action?.param) {
                state.setFilter[action.payload.action.destination] = {
                    action: null
                }
                return
            }

            const newFilter = creatingFilter(action.payload.action, state.globalValues, action.payload.screenName);
            const destination = getParamsFromString(action.payload.action.destination, state.globalValues, state.screenName)
            state.setFilter[destination] = {
                action: {
                    ...action.payload.action,
                    destination
                },
                context: action.payload.context,
                createdFilter: newFilter
            }
        },
        setListData: (state, action) => {
            const {action: act, screenName, fromAction} = action.payload;
            state.listData[act.destination] = fromAction ? paramGetter({
                action: act,
                globalValues: state.globalValues,
                screenName
            }) : act.param;
        },
        setPivotSettings: (state, action) => {
            const {action: act, screenName, fromAction} = action.payload;
            state.pivotSettings[act.destination] = fromAction ? paramGetter({
                action: act,
                globalValues: state.globalValues,
                screenName
            }) : act.param;
        },
        setPopup: (state, action) => {
            state.popup = {
                ...state.popup,
                [action.payload.name]: action.payload,
            };
        },
        closePopup: (state, action) => {
            state.screenName = state.popup[action.payload.name]?.parentScreen
            state.popup = {
                ...state.popup,
                [action.payload.name]: {},
            };
        },
        setIsChanged: (state, action) => {
            state.isChangedFields = action.payload;
        },
        setScreen: (state, action) => {
            state.screen = {
                ...state.screen,
                ...action.payload
            };
        },
        setSession: (state, action) => {

            sessionStorage.setItem(action.payload.key, typeof action.payload.value === 'object' ? JSON.stringify(action.payload.value) : action.payload.value)

            const sessionObject =
                typeof action.payload.value === 'object' ? action.payload.value :
                    {[action.payload.key]: action.payload.value}
            state.globalValues.sessionStorage = {...state.globalValues.sessionStorage, ...sessionObject};
            state.globalValues.session = {...state.globalValues.session, ...sessionObject};
        },
        setFieldValue: (state, action) => {
            const {value, path, trackChange} = action.payload;
            let newValues = set(state.globalValues, path, value);
            let entity = path?.split('.')[2]
            let field = path?.split('.')[path?.split('.').length - 1];
            if (trackChange) {
                newValues = set(newValues, `${path}Changed`, true);
            }

            if (state.forms?.[entity] && state.forms?.[entity].status) {
                let errors = state.forms?.[entity].status.message;
                if (errors && errors.length) {
                    let errorIndex = errors.findIndex(v => v.field === field);

                    //if field error found, clear from state after value was changed
                    if (errorIndex !== -1) {
                        state.forms[entity].status.message = errors.filter((v, i) => {
                            return i !== errorIndex
                        })
                    }

                }
            }
            state.globalValues = newValues;
        },
        handleFormValidators: (state, action) => {
            const {isValid} = action.payload;
            state.form.isValid = isValid;
        },
        clearFile: (state, action) => {
            const {action: act, screenName} = action.payload;
            const fileObject = getParamsFromString(`{${act.fieldId}}`, state.globalValues, screenName);
            //remove from value
            state.globalValues.param[screenName] = del(state.globalValues.param[screenName], act.fieldId);
            //remove from memory
            URL.revokeObjectURL(fileObject.content);

            //remove from garbage
            const fGarbage = state.filesGarbage[screenName];
            if (fGarbage && fGarbage.length) {
                state.filesGarbage[screenName] = fGarbage.filter(f => f !== fileObject.content)
            }

            //remove link
            const filesLink = state.uploadedFilesLinks[screenName]
            if (filesLink && filesLink.length) {
                state.uploadedFilesLinks[screenName] = filesLink.filter(f => f !== act.fieldId)
            }

            //clear input
            const inputField = document.getElementById(act.fieldId);
            if (inputField) {
                inputField.value = ''
            }
        },
        setCameraScreenshotContent: (state, action) => {
            const {action: {destination}, screenName, imageSource} = action.payload;
            const {globalValues: {param}} = state;
            state.globalValues.param = set(param, `${screenName}.${destination}`, imageSource)
        },
        setComponentProperty: (state, action) => {
            const {screenName} = state;
            const {path, property, value, componentId} = action.payload;
            let currentPath = path;
            const refs = state.screen?.[state.screenName]?._refs || [];
            if(componentId) {
               // console.log('path', refs.find(v => v.id === componentId)?.ref)
                currentPath = refs.find(v => v.id === componentId)?.ref
            }

            let newValues = state.screen[screenName];
            if (Array.isArray(currentPath)) {

                for (let pathItem of currentPath) {
                    newValues = set(newValues, pathItem + '.properties.' + property, value);
                }
            } else {
                newValues = set(state.screen[screenName], currentPath + '.properties.' + property, value);
            }

            try {
                state.screen = {...state.screen, [screenName]: newValues};
            } catch (e) {
                console.log(e)
            }
        }
    },
    extraReducers: {
        [sendRequest.fulfilled]: (state, action) => {
            const {setToVar, data} = action.payload;
            if (setToVar) {
                state.globalValues.param = set(state.globalValues.param, `${action.payload.screenName}.${setToVar}`, data);
            }
            state.loading = false;
        },
        [sendRequest.pending]: state => {
            state.loading = true
        },
        [sendRequest.rejected]: state => {
            state.loading = false
        },

        [getListData.fulfilled]: (state, action) => {
            const {setToVar, data, screenName} = action.payload;
            if (setToVar) {
                state.globalValues.param = set(state.globalValues.param, `${screenName}.${setToVar}`, data);
            }
            state.loading = false;
        },
        [getListData.pending]: state => {
            state.loading = true
        },
        [getListData.rejected]: state => {
            state.loading = false
        },

        [readRecord.fulfilled]: (state, action) => {
            const {path, data} = action.payload;
            state.globalValues.param = set(state.globalValues.param, path, data)
            state.loading = false;
        },
        [readRecord.pending]: state => {
            state.loading = true
        },
        [readRecord.rejected]: state => {
            state.loading = false
        },

        [getNewScreen.fulfilled]: (state, action) => {
            let refs = [];
            let fieldRefs = [];
            let dataSources = action.payload?.otherComponents?.filter(v => v.type === 'dataSource');
            try {
                if (action.payload.children) {
                    refs = flatten(action.payload.children, x => x.children).map(v => {
                        return {
                            type: v.type,
                            ref: v._path,
                            id: v.id,
                            properties: {
                                path: v.properties?.path
                            }
                        }
                    });
                }
            } catch (e) {
                console.log(e)
            }

            fieldRefs = refs.filter(v => v.properties.path && v.type === 'field').map(v => ({
                id: v.id,
                type: v.type,
                ref: v.ref,
                path: v.properties.path
            }))

            state.screen = {
                ...state.screen,
                [action.payload.id]: {
                    ...action.payload,
                    _refs: refs,
                    _fields: fieldRefs
                }
            }
            state.dataSources = dataSources;
            if (action.payload.script) {
                state.globalValues._preScript = action.payload.script
            }

            state.loading = false
        },
        [getNewScreen.pending]: state => {
            state.loading = true
        },
        [getNewScreen.rejected]: state => {
            state.loading = false
        },

        [startProcess.fulfilled]: (state, action) => {
            const clearActions = del(action.payload, '_actions');
            state.globalValues = {...state.globalValues, task: clearActions}
            state.loading = false;
        },
        [startProcess.pending]: state => {
            state.loading = true
        },
        [startProcess.rejected]: state => {
            state.loading = false
        },

        [completeTask.fulfilled]: (state, action) => {
            const clearActions = del(action.payload, '_actions');
            state.globalValues = {...state.globalValues, task: clearActions}
            state.loading = false;
        },
        [completeTask.pending]: state => {
            state.loading = true
        },
        [completeTask.rejected]: state => {
            state.loading = false
        },

        [deleteTask.fulfilled]: state => {
            state.loading = false;
        },
        [deleteTask.pending]: state => {
            state.loading = true
        },
        [deleteTask.rejected]: state => {
            state.loading = false
        },

        [startTask.fulfilled]: (state, action) => {
            const clearActions = del(action.payload, '_actions');
            state.globalValues = {...state.globalValues, task: clearActions}
            state.loading = false;
        },
        [startTask.pending]: state => {
            state.loading = true
        },
        [startTask.rejected]: state => {
            state.loading = false
        },

        [jsExecutor.fulfilled]: () => {
        }
    }
});

export const {
    setStringFilter,
    setQueryParams,
    setScreenName,
    setGlobalValues,
    setInParam,
    clearGlobalValues,
    setVariable,
    setFormData,
    setLoading,
    disableAllFields,
    enableAllFields,
    uploadFile,
    refreshData,
    setRefreshDataFalse,
    setFilter,
    setListData,
    setPivotSettings,
    setPopup,
    closePopup,
    setIsChanged,
    setScreen,
    setSession,
    setFieldValue,
    handleFormValidators,
    clearFile,
    setCameraScreenshotContent,
    setComponentProperty
} = jsonScreenSlice.actions;
export {
    sendRequest,
    readRecord,
    getListData,
    startProcess,
    completeTask,
    deleteTask,
    startTask,
    jsExecutor,
    getNewScreen
}
export default jsonScreenSlice.reducer;
